import { CSSProperties } from 'react'

import { cn } from '@/shared/lib'
import { Image } from '@/shared/ui'

import { Profile as ProfileIcon } from '../asset'

export const EMPTY_IMAGE =
  'data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgODggODgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF84ODUzXzE4MTY1MikiPgo8cmVjdCB3aWR0aD0iODgiIGhlaWdodD0iODgiIGZpbGw9IiNEN0Q3RDciLz4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAxXzg4NTNfMTgxNjUyKSI+CjxyZWN0IHdpZHRoPSI4OCIgaGVpZ2h0PSI4OCIgZmlsbD0iI0Q3RDdENyIvPgo8Y2lyY2xlIGN4PSI0NCIgY3k9IjQ0IiByPSI0NCIgZmlsbD0iI0Q3RDdENyIvPgo8Y2lyY2xlIGN4PSI0NC4wMDAyIiBjeT0iMzcuNDAwNSIgcj0iMTUuODQiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik00NC4yOTM4IDU4LjA4NEM2Mi40OTA1IDU4LjI2NiA3Ny4xNDU0IDY2Ljg2MjEgNzcuMTQ1NCA3Ny40NDA0Qzc4LjcwMDUgMTA3LjQwNiA3NS4yMjY2IDExMy40NjEgNDMuOTk4OSAxMDcuNTU1QzEyLjc3MTkgMTEzLjQ2MSA5LjI5ODMxIDEwNy40MDYgMTAuODUzNCA3Ny40NDA0QzEwLjg1MzQgNjYuODYyMSAyNS41MDgzIDU4LjI2NTkgNDMuNzA1IDU4LjA4NFY1OC4wODAxQzQzLjgwMzEgNTguMDgwMSA0My45MDEgNTguMDgxNSA0My45OTg5IDU4LjA4MkM0NC4wOTcxIDU4LjA4MTUgNDQuMTk1NCA1OC4wODAxIDQ0LjI5MzggNTguMDgwMVY1OC4wODRaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfODg1M18xODE2NTIiPgo8cmVjdCB3aWR0aD0iODgiIGhlaWdodD0iODgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjxjbGlwUGF0aCBpZD0iY2xpcDFfODg1M18xODE2NTIiPgo8cmVjdCB3aWR0aD0iODgiIGhlaWdodD0iODgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=='

type Props = {
  src?: string
  alt: string
  size?: number
  className?: string
  style?: CSSProperties
  imageStyle?: CSSProperties
}

const ProfileFallback = ({ size, alt, className }: Omit<Props, 'src'>) => {
  return (
    <div>
      <ProfileIcon
        width={size}
        height={size}
        className={cn('rounded-full border border-gray-50', className)}
      />
      <span className="sr-only">{alt}</span>
    </div>
  )
}

export const Profile = ({
  src,
  alt,
  size = 88,
  className,
  style,
  imageStyle,
}: Props) => {
  if (!src) {
    return <ProfileFallback size={size} alt={alt} className={className} />
  }

  return (
    <Image
      src={src}
      alt={alt}
      width={size}
      height={size}
      external
      priority
      className={cn('rounded-full border border-gray-50', className)}
      fallback={<ProfileFallback size={size} alt={alt} className={className} />}
      placeholder={EMPTY_IMAGE}
      style={style}
      imageStyle={imageStyle}
    />
  )
}
